import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Icon from '../Icon';

const SliderItem = ({
  id,
  image,
  onClick,
  url,
  active,
  name,
}) => {
  const className = classnames('SliderItem', {
    active,
  });
  const handleClick = (e) => {
    e.preventDefault();
    onClick(id);
  };

  const href = url || `#${id}`;

  return (
    <div className={className}>
      <a className="SliderItem__anchor" href={href} onClick={handleClick}>
        <div
          className="SliderItem__image"
          style={{ backgroundImage: `url('${image}')` }}
        />

        <div className="SliderItem__backdrop" />

        <div className="SliderItem__title text-uppercase">
          {name}
          <br />
          <div className="SliderItem__check">
            <Icon name="check" size="2x" fw />
          </div>
        </div>
      </a>
    </div>
  );
};

SliderItem.propTypes = {
  id: PropTypes.number.isRequired,
  image: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  url: PropTypes.string,
  active: PropTypes.bool,
  name: PropTypes.string.isRequired,
};

SliderItem.defaultProps = {
  onClick: () => {},
  url: null,
  active: false,
};

export default SliderItem;
